import { render, staticRenderFns } from "./DeliveryInput.vue?vue&type=template&id=142d6b30&scoped=true&lang=pug"
import script from "./DeliveryInput.vue?vue&type=script&lang=js"
export * from "./DeliveryInput.vue?vue&type=script&lang=js"
import style0 from "./DeliveryInput.vue?vue&type=style&index=0&id=142d6b30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142d6b30",
  null
  
)

export default component.exports